import { UnsupportedReason } from '../../types';
import client from './client';

export default (
	unsupportedReason: UnsupportedReason,
	bookName: string | undefined,
	userName: string,
	service: string | null,
	internalId: string
) => {
	console.warn('Unsupported Popup', {
		context: 'BookLoginPage#unsupportedReason',
		bookName,
		userName,
		sdkService: service,
		internalId,
		unsupportedReason: UnsupportedReason[unsupportedReason],
	});

	client.warn('Unsupported Popup', {
		context: 'BookLoginPage#unsupportedReason',
		bookName,
		userName,
		sdkService: service,
		internalId,
		unsupportedReason: UnsupportedReason[unsupportedReason],
  	});
};
